module.exports = __webpack_public_path__ + "static/legends-4-528e169174fe151d6ff3e537dc3778d8.jpg";